import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor() {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        // todo: retry request without custom headers (copy issue)
        // retry(1),
        catchError((error: HttpErrorResponse) => {
          let errorMsg: any = 'Unknown error.';
          if (error.error instanceof ErrorEvent) {
            // client side error
            console.log('this is client side error');
            // errorMsg = `Error: ${error.error.message}`;
            // errorMsg = `Error: ${error.error.message}`;
            errorMsg = {
              message: error.error.message
            }
          } else if (error.error && error.error.message) {
            if (error.error.code.toString() === '1501') {
              console.log('Entity with the specified id already exists in the system.');
              // errorMsg = `Entity with the specified id already exists in the system.`;
              errorMsg = {
                message: `Entity with the specified id already exists in the system.`
              }
            } else if (error.error.code.toString() === '409') {
              errorMsg = {
                errorCode: error.error.code,
                message: `Entity with the specified id already updated by another user. Please refresh the page.`,
                data: error.error.data ?? []
              }
            } else if (error.error.code === 1501) {
              console.log(error.error.meaning);
              errorMsg = error.error.meaning;
              errorMsg = {
                message: error.error.meaning
              }
            } else {
              // server side error
              console.log('this is server side error');
              // errorMsg = `Error Code: ${error.status}\nMessage: ${error.error.message}`;
              errorMsg = {
                errorCode: error.status,
                message: error.error.message
              }
            }
          } else {
            // server side error
            console.log('this is server side error');
            // errorMsg = `Error Code: ${error.status}\nMessage: ${error.message}`;
            errorMsg = {
              errorCode: error.status,
              message: error.message
            }
          }
          return throwError(errorMsg);
        })
      );
  }
}
